
interface PaymentUnavailableMessageProps {
  paymentMethod: string;
}

const PaymentUnavailableMessage = ({ paymentMethod }: PaymentUnavailableMessageProps) => {
  return (
    <div className="text-center p-8 border rounded-lg border-dashed">
      <p className="text-gray-500">
        {paymentMethod === 'apple-pay' && 'Apple Pay is not available on this device or browser.'}
        {paymentMethod === 'google-pay' && 'Google Pay is not available on this device or browser.'}
        {' Please try a different payment method.'}
      </p>
    </div>
  );
};

export default PaymentUnavailableMessage;
